import { Component, Input, OnInit, EventEmitter, Output, ChangeDetectorRef, HostBinding } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'expanding-wrapper',
    template: `
<div class="expanding-wrapper" *ngIf="{ open: expandedState === 'expand' } as vars">
  <div [class]="'wrapper-area '+expandedState" 
    [ngClass]="{'grey-on-collapse':borderGreyOnCollapse, warning: warning, 'dark-on-expand':borderDarkOnExpand, 'dark-on-collapse':borderDarkGreyOnCollapse, noBottom: !!bottomHeight}" >
    <div class="wrapper-title" (click)="toggle()"
      [ngClass]="{ padded: padded, collapse: !vars.open, done: done, warningBG: warning && !vars.open, stacked: stackedMobile }"
      > <!-- DEFAULTS TO USING TITLE AS THE CLICKABLE FOR EXPANDING / COLLAPSING -->
      <div class="left-holder" [ngClass]="{ noSpacerLeft: noSpacerLeft }">
        <mat-icon *ngIf="!hideArrow">{{expandedState === 'collapse' ? 'arrow_right' : 'arrow_drop_down'}}</mat-icon>
        <div [ngClass]="{grayText: !title && titlePlaceholder} " *ngIf="(title || titlePlaceholder) && !(hideTitleOnExpand && vars.open)">{{ title || titlePlaceholder }}</div>
        <ng-content select=".header-left"></ng-content>
      </div>
      <div style="flex:1;" *ngIf="!noSpacerLeft"></div>
      <ng-content select=".header-middle"></ng-content>
      <div style="flex:1;" *ngIf="!noSpacerRight"></div>
      <ng-content select=".header-right"></ng-content>
      <icon *ngIf="!!rightIcon" [icon]="rightIcon"></icon>
      <icon class="delete-icon" *ngIf="showTrash && vars.open" icon="delete18" (click)="delete.emit()"></icon>
    </div>
    <!--<div class="wrapper-title mobile" *ngIf="stackedMobile" (click)="toggle()" [ngClass]="{ padded: padded, collapse: !vars.open, done: done, warningBG: warning && !vars.open }">
      <div class="left-holder" [ngClass]="{ noSpacerLeft: noSpacerLeft }">
        <mat-icon *ngIf="!hideArrow">{{expandedState === 'collapse' ? 'arrow_right' : 'arrow_drop_down'}}</mat-icon>
      </div>
      <div class="right">
        <div [ngClass]="{grayText: !title && titlePlaceholder} " *ngIf="(title || titlePlaceholder) && !(hideTitleOnExpand && vars.open)">{{ title || titlePlaceholder }}</div>
        <ng-content select=".header-left"></ng-content>
        <ng-content select=".header-middle"></ng-content>
        <ng-content select=".header-right"></ng-content>
    </div>-->

    <div class="content" 
      [ngClass]="{collapse: !vars.open}" 
      [@drop]="{value: expandedState, params: {animationMS: animationMS }}"
      (@drop.start)="startToggle()"
      (@drop.done)="endToggle()"
      >
      <div class="inner-content" [ngClass]="{padded: padded}">
        <ng-content select=".top-of-content"></ng-content>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div *ngIf="!!bottomHeight" 
    class="expanding-bottom" 
    [ngStyle]="{height: !vars.open ? 0 : bottomHeight}"
    [ngClass]="{padded: padded}">
    <ng-content select=".bottom"></ng-content>
  </div>
</div>
`,
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0px' })),
            transition('* => *', animate("{{ animationMS }}" + 'ms'), { params: { animationMS: 300 } }),
            transition('void => *', [animate('0ms')]),
            transition('undefined => *', [animate('0ms')])
        ])
    ],
    styleUrls: ['expanding-wrapper.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, MatIconModule],
})
export class ExpandingWrapperComponent implements OnInit {
  @Input() title
  @Input() hideArrow = false // for when you want an expanding wrapper to pretend not to be an expanding wrapper ha
  @Input() titlePlaceholder
  @Input() hideTitleOnExpand = false
  @Input() bottomHeight = null
  @Input() padded
  @Input() warning = false
  @Input() animationMS = 300
  @Input() showTrash = false
  @Input() borderGreyOnCollapse = false
  @Input() borderDarkGreyOnCollapse = false
  @Input() borderDarkOnExpand = false
  @Input() initOpen = false
  @Input() rightIcon: string // because session info is a nested expanding wrapper with select already working at a higher level have to make workarounds to enable stuff to show up in the wrapper upper area.  Hopefully not too many
  @Input() noSpacerLeft = false
  @Input() noSpacerRight = false
  @Input() stackedMobile = false

  @Output() delete: EventEmitter<void> = new EventEmitter()
  @Output() onDone: EventEmitter<void> = new EventEmitter()
  @Output() onToggle: EventEmitter<void> = new EventEmitter();
  

  done = true
  togglingNow = false
  
  @Input() expandedState: 'expand' | 'collapse' = 'collapse'
  @Input() manualToggle = false

  @HostBinding('class.expanded')
  get displayStyle() {
    return this.expandedState === 'expand'
  }

  constructor(private changeDetectorRef:ChangeDetectorRef) {}

  toggle() {
    // console.log("TOGGLING")
    if (!this.manualToggle) this.expandedState = this.expandedState === 'collapse' ? 'expand' : 'collapse'
    this.onToggle.emit()
  }

  ngOnInit(){
    if (this.initOpen) this.expandedState = 'expand';
  }

  startToggle() {
    // console.log("Toggling...")
    this.done = false
    this.changeDetectorRef.detectChanges() // easiest (maybe only?) way to get rid of change detection errors when toggling multiple times before animation is done
  }
  endToggle() {
    // console.log("Toggling done...")
    this.done = true
    this.changeDetectorRef.detectChanges() 
    this.onDone.emit()
  }
}

